<template>
  <div class="main-content queryBillPayment">
    <search-item
      :key="identify"
      :ref="identify"
      :is-append-query="isAppendQuery"
      :show-more-scheme="true"
      :show-simple="showSimple"
      :expand-adv="true"
      :search-item-code="searchItemCode"
      :config-module="configModule"
      :grid-config-module="gridConfigModule"
      :auto-init="searchItemAutoInit"
      :custom-search-items="customSearchItems"
      :custom-sim-query-placeholder="simQueryPlaceholder"
      :col-settings="colSettings"
      @advSearchItemCallBack="fetchData"
      @simSearchItemCallBack="fetchDataBykeyWord"
      @advToggle="scrollCallback"
      @perConfigChange="value=>{perConfigName=value}"
      @refreshGrid="()=>{gridRefreshId+=1}"
      @defaultSearchItemsChange="value=>{defaultSearchItems=value}"
    >
      <template slot="operations">
        <slot name="operations" />
      </template>
      <template slot="searchAreaHeader">
        <slot name="searchAreaHeader" />
      </template>
      <template slot="other">
        <slot name="other" />
      </template>
    </search-item>
    <div class="section grid-wrapper">
      <cargo-ag-grid-wrapper
        :config-module="gridConfigModule"
        :per-config-name="perConfigName"
        :refresh-id="gridRefreshId"
        :grid-params.sync="billPaymentGrid.gridParams"
        :grid-options="billPaymentGrid.gridOptions"
        :column-defs="dynamicColumnDefs"
        :row-data="billPaymentGrid.rowData"
        :min-height="hasVoucher===0?'350px':'200px'"
        :show-row-groups="dataListDragGroup"
      />
    </div>
    <div id="footer-wrapper-tab-billpayment" class="pagination-wrapper">
      <div :class="[shouldFixed?'fixedBottom':'']" style="display: flex;justify-content: flex-end;flex-wrap: wrap">
        <span v-if="dataShow && ['billPaymentList', 'Writeoff', 'financeAp'].includes(viewSource)" v-text="totalAmountToCurrencyBillPaymentGrid.labelText" />
        <span v-if="['billPaymentList', 'Writeoff', 'financeAp'].includes(viewSource)" v-text="totalAmountToCurrencyBillPaymentGrid.selectionCountLabel" />
        <charge-currency-total-group
          v-if="reCalc"
          :key="1"
          :type="totalType"
          :amount-to-currency="localCurrency"
          :data-field="totalDataField"
          :data-provider="totalAmountToCurrencyBillPaymentGrid.dataProvider"
          :rate-field="rateField"
          :ar-field="arField"
          :show-wht="showWht"
        />
        <span v-if="showTotalUnverifiedAmount && ['billPaymentList', 'Writeoff', 'financeAp'].includes(viewSource)" v-text="totalAmountNotWrittenOffLabel" />
        <charge-currency-total-group
          v-if="reCalc && showTotalUnverifiedAmount && ['billPaymentList', 'Writeoff', 'financeAp'].includes(viewSource)"
          :key="2"
          :type="totalType"
          :amount-to-currency="localCurrency"
          data-field="unverifiedAmount"
          :data-provider="totalAmountToCurrencyBillPaymentGrid.dataProvider"
          :rate-field="rateField"
          :ar-field="arField"
          :show-wht="showWht"
        />
        <charge-sum-by-currency
          v-if="reCalc"
          :key="3"
          :data-provider="totalAmountToCurrencyBillPaymentGrid.dataProvider"
        />
      </div>
      <div v-show="appendQuery" class="pagination-container">
        <el-pagination
          style="text-align: left;"
          :total="searchConditions.total"
          layout="total"
        />
      </div>
      <cargo-pagination
        v-show="!appendQuery"
        ref="paginationBillPayment"
        :config-module="`${gridConfigModule}${state.join('')}${paidOff}`"
        :total="searchConditions.total"
        :page.sync="searchConditions.pageNum"
        :limit.sync="searchConditions.pageSize"
        @pagination="fetchDataByPage"
      />
    </div>
    <!-- 付款申请审批流 -->
    <bill-payment-work-flow-apply-dialog
      v-if="workFlowApplyDialog.visible"
      :visible.sync="workFlowApplyDialog.visible"
      :bill-payment="workFlowApplyDialog.billPayment"
      :title="$t('CargoMsg.Cargo_Approving')"
      :process-info="workFlowApplyDialog.documentProcess"
      :records="workFlowApplyDialog.approvalCommentsRecords"
      type="approve"
      @close="workFlowApplyDialog.visible=false"
      @closeAndRefresh="()=> {
        workFlowApplyDialog.visible = false
        fetchDataByPage()
      }"
    />
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import chargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroup.vue'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import { getGridSelected, recordSelectedStatus } from '@/utils/agGrid'
import { getLoading } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cacheName, cache } from '@/utils/cacheManager'
import StrUtils from '@/utils/StrUtils'
import { DocumentManage, ensureExecuteSuccess, Once, stringToBool } from '@/utils/commonUtil'
import { queryBillPaymentList } from '@/api/clearing/billPayment'
import lodash from 'lodash'
import moment from 'moment'
import * as NumberUtils from '@/utils/NumberUtils'
import * as LoadDefaultQueryParam from '@/utils/LoadDefaultQueryParam'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import {
  BILL_PAYMENT_NOT_COMMIT,
  BILL_PAYMENT_COMMITED,
  BILL_PAYMENT_BIZ_APPROVED,
  BILL_PAYMENT_FINANCE_APPROVED,
  BILL_PAYMENT_DEP_APROVED,
  BILL_PAYMENT_APPROVING_BPM, BILL_PAYMENT_APPROVED_BPM
} from '@/class/cargo/model/parameters/ClearingConstants'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getObjectByCache, getCacheListByKey } from '@/utils/basicDataCache'
import * as SpecialFieldConstants from '@/utils/SpecialFieldConstants'
import * as AdvancedSearchConsts from '@/class/cargo/model/utils/AdvancedSearchConsts'
import CargoGridShowBigContent from '@/components/Cargo/grid/cargoGridShowBigContent'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { jumpFinaceOrBusiness } from '@/components/Cargo/grid/routerAndPrintHelp'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import * as ClearingConstants from '@/class/cargo/model/parameters/ClearingConstants'
import { WorkflowUtil } from '@/class/cargo/model/utils/WorkflowUtil'
import BillPaymentWorkFlowApplyDialog from '@/components/Cargo/Common/Wrokflow/billPaymentApplyDialog'
import cargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper.vue'
import * as ChargeConstants from '@/class/cargo/model/parameters/ChargeConstants'
import ChargeSumByCurrency from '@/components/Cargo/Act/chargeSummary/ChargeSumByCurrency.vue'
import ChargeCountField from '@/components/Cargo/Act/chargeSummary/ChargeCountField'
import ChargeCountManager from '@/components/Cargo/Act/chargeSummary/ChargeCountManager'
import ChargeCountDataAdapte from '@/components/Cargo/Act/chargeSummary/ChargeCountDataAdapte'
import ChargeGroupCounter from '@/components/Cargo/Act/chargeSummary/ChargeGroupCounter'

export default {
  name: 'QueryBillPayment',
  components: { ChargeSumByCurrency, cargoAgGridWrapper, searchItem, chargeCurrencyTotalGroup, CargoGridShowBigContent, BillPaymentWorkFlowApplyDialog },
  props: {
    isAppendQuery: { type: Boolean, default: false }, // 追加查询，默认不显示
    identify: { type: String, required: true, default: 'queryBillPayment' }, // ID
    viewSource: { type: String, required: true, default: 'billPaymentList' }, // 引用页面
    isAr: { type: Number, default: -1 }, // 是否应收
    oversea: { type: Number, default: -1 }, // 国内国外 0:国内 1:国外
    state: { type: Array, default: () => [] }, // 付款申请状态
    clearingStates: { type: Array, default: () => [] }, // 核销状态
    jobStates: { type: Array, default: () => [] }, //
    finApproveState: { type: Array, default: () => [] }, // 最终审核状态
    isCheckCharge: { type: Boolean, default: false }, // 检查费用开票状态
    paidOff: { type: Number, default: -1 }, // 是否销账
    inputDateStart: { type: String, default: moment().subtract(2, 'y').format('yyyy-MM-DD') }, // 默认业务日期查询
    inputDateEnd: { type: String, default: '' },
    showInvoiceNoColumn: { type: Boolean, default: true }, // 是否显示对方发票号
    showTotalUnverifiedAmount: { type: Boolean, default: false }, // 显示未销金额总计
    showVerifiedAmount: { type: Boolean, default: true }, // 是否显示已核销金额
    showUnverifiedAmount: { type: Boolean, default: true }, // 是否显示未核销金额
    showRealClearingState: { type: Boolean, default: true }, // 显示真实的核销状态
    showControlledCharge: { type: Boolean, default: true }, // 是否显示受控费用
    showSelectionCount: { type: Boolean, default: true }, // 是否显示选中记录数
    showGroupingTotal: { type: Boolean, default: true }, // 是否显示合计
    showChargeCount: { type: Boolean, default: false }, // 是否显示合计:新组件
    showFba: { type: Boolean, default: false }, // 显示FBA相关列
    selectedEntitiesForHedging: { type: Array, default: () => [] }, // 排除
    exceptKeys: { type: Array, default: () => [] }, // 在查询中想要例外的Keys
    exceptAdvancedSearchOption: { type: Object, default: null },
    accountId: { type: Number, default: 0 }, // 对冲销账结算单位
    jobStateParam: { type: String, default: 'BillPaymentJobState' }, // BillPaymentJobState, 付款申请-费用-业务状态查询(付款申请)
    totalType: { type: String, default: 'both', validator: (value) => { return ['revenue', 'ar', 'ap', 'both', 'revenueAbs', 'auto'].includes(value) } }, // 合计类型
    totalDataField: { type: String, default: 'amount' }, // 数据字段
    totalCurrencyField: { type: String, default: 'currency' }, // 币种字段
    totalAmountToCurrency: { type: String, default: 'RMB' }, // 折合币种
    rateField: { type: String, default: 'converRate' }, // 汇率字段
    arField: { type: String, default: 'ar' }, // 收付字段
    type: { type: String, default: 'both', validator: (value) => { return ['revenue', 'ar', 'ap', 'both', 'revenueAbs', 'auto'].includes(value) } }, // // 合计类型
    showTotalGroup: { type: Boolean, default: true }, // 是否显示合计
    arapGroup: { type: Boolean, default: false }, // 是否分实收实付
    defaultOptions: { type: Array, default: () => [] }, // 默认的选项
    defaultOptionValues: { type: Array, default: () => [] }, // 选项的默认值列表
    configModule: { type: String, default: '508' }, // 高级查询条件
    gridConfigModule: { type: String, default: '190801' }, // 列表设置
    showSimple: { type: Boolean, default: true },
    isExt: { type: Boolean, default: false },
    accountSetKey: { type: String, default: '' }, // 账套uuid
    hasVoucher: { type: Number, default: -1 }, // 是否已经生成过凭证:1=是,0=否
    colSettings: { type: Object },
    internalCharge: { type: Boolean, default: false }, // 内结
    accountSetBranchId: { type: Number, default: 0 }, // 账套branchId
    isBpm: { type: Boolean, default: false }, // 是否bpm=付款申请（新版）
    showWht: { type: Boolean, default: false }, // 是否需要展示去Wht金额
    showCreditPeriod: { type: Boolean, default: false }, // 展示期账
    isDefaultBillPayment: { type: Boolean, default: false } // 是否默认付款申请
  },
  data() {
    return {
      localCurrency: 'RMB',
      reCalc: true,
      isItACommercialAudit: false,
      dataShow: true, // 底部计算组件文字是否显示
      loading: false,
      customSearchItems: [], // 自定义高级查询项
      defaultSearchItems: [],
      searchItemAutoInit: true,
      searchItemCode: '付款申请查询',
      // configModule: '505',
      simQueryPlaceholder: this.$t('CargoMsg.Cargo_QuickSearchBillPayment'),
      perConfigName: '',
      gridRefreshId: 0,
      billPaymentGrid: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          context: {
            componentParent: this
          },
          defaultColDef: {
            resizable: true,
            filter: true
          },
          pagination: false,
          onSelectionChanged: this.toRefreshSelectedCountChargeGrid,
          onRowSelected: this.onRowSelected,
          onRowClicked: this.onRowClicked,
          onRowDoubleClicked: this.onRowDoubleClicked
        },
        rowData: []
      },
      searchConditions: {
        total: 0,
        pageNum: 1,
        pageSize: 20,
        requires: ['voucherNoCreateDate', 'targetVoucherNo'],
        snapshotConditions: [], // 高级查询条件（点击查询时的快照状态）
        jobStates: [] // 业务状态
      },
      totalAmountToCurrencyBillPaymentGrid: { // 右下角合计组件相关参数
        labelText: '',
        selectionCountLabel: '',
        dataProvider: [], // 数据源
        selectedCount: 0, // 选中条数
        displayAndCountFieldList: [ // 需要统计的项
          new ChargeCountField(this.$t('Billing.billingView_receivables'),
            'amount', 'currency', null, ChargeCountManager.DISP_IN_GRID, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'ar', ChargeGroupCounter.OPERATOR_EQUAL, true)
            ]),
          new ChargeCountField(this.$t('Billing.billingView_payables'),
            'amount', 'currency', null, ChargeCountManager.DISP_IN_GRID, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'ar', ChargeGroupCounter.OPERATOR_EQUAL, false)
            ]),
          new ChargeCountField(this.$t('Billing.billingView_total'),
            'amount', 'currency', null, ChargeCountManager.DISP_IN_GRID, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'ar', ChargeGroupCounter.OPERATOR_EQUAL, true),
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_SUBTRACT, 'ar', ChargeGroupCounter.OPERATOR_EQUAL, false)
            ]),
          new ChargeCountField(this.$t('Invoice.invoice_convert'),
            'amount', 'currency', 'rate', ChargeCountManager.DISP_IN_GROUP, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'ar', ChargeGroupCounter.OPERATOR_EQUAL, true),
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_SUBTRACT, 'ar', ChargeGroupCounter.OPERATOR_EQUAL, false)
            ])
        ]
      },
      once: new Once(this),
      selectedItem: {}, // 表格选中项
      selections: [], // 已经选中列表
      shouldFixed: false,
      queryOfficeId: 0, // 记录查询时的当前分公司ID
      appendQuery: false, // 追加查询
      workFlowApplyDialog: {
        visible: false
      },
      dataListDragGroup: false, // 是否支持数据列表拖拽分组特性
      documentManage: new DocumentManage()
    }
  },
  computed: {
    showWhtTax() {
      return this.showWht && this.$store.getters.currentOffice.whtTaxMode
    },
    dynamicColumnDefs() {
      const columnDefs = [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('WriteOff.paymentNotificationNo'), field: 'billPaymentNo', width: 200, enableRowGroup: true
        },
        {
          headerName: this.$t('Payment.settleAccountsTo'), field: 'accountId', width: 300, enableRowGroup: true,
          cellRenderer: (params) => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_accountId') : ''
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SettlementType'),
          field: 'settlementType',
          colId: 'settlementType',
          cellRenderer: (params) => {
            return ColumnUtils.settlementTypeCommonLabelFunc(params.data)
          },
          filterParams: {},
          width: 150,
          hide: true,
          filterValueGetter: params => ColumnUtils.settlementTypeCommonLabelFunc(params.data)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AccountPeriod'),
          field: 'creditDateLimited',
          colId: 'creditDateLimited',
          width: 100,
          hide: true,
          cellRenderer: params => ColumnUtils.AccountPeriodCommonLabelFunc(params.data),
          filterParams: {},
          filterValueGetter: params => ColumnUtils.AccountPeriodCommonLabelFunc(params.data)
        },
        // 额度 （currency单位RMB-RMB，USD-USD）（credit额度）
        {
          headerName: this.$t('baseInfo.partner.quota'),
          field: 'quota',
          width: 200,
          hide: true,
          cellRenderer: params => ColumnUtils.creditCommonLabelFunc(params.data),
          filterParams: {},
          filterValueGetter: params => ColumnUtils.creditCommonLabelFunc(params.data)
        },
        {
          headerName: this.$t('Payment.settlementAgent'), field: 'settlementAgentId', width: 300, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Payment.consignationCompany'), field: 'customerChineseName', width: 300, enableRowGroup: true,
          valueGetter: (params) => {
            if (params.data) {
              return ColumnUtils.customerLabelFunc(params.data)
            }
          }
        },
        // 更新时间
        {
          headerName: this.$t('Payment.dateModified'), field: 'dateModified', width: 300, enableRowGroup: true
        },
        // 更新人
        {
          headerName: this.$t('Payment.modifiedBy'), field: 'modifiedBy', width: 300, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Payment.invoiceHeader'), field: 'invoiceTitle', width: 300, enableRowGroup: true,
          valueGetter: (params) => {
            if (params.data) {
              return params.data.billPaymentInvoiceTitle ? params.data.billPaymentInvoiceTitle : params.data.invoiceTitle
            }
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return params.data.billPaymentInvoiceTitle ? params.data.billPaymentInvoiceTitle : params.data.invoiceTitle
          }
        },
        // {
        //   headerName: this.$t('Payment.businessNumber'),
        //   field: 'jobNo',
        //   width: 200,
        //   cellRendererFramework: 'agGridColumnEdit',
        //   custom: {
        //     tag: 'multi-router-and-print',
        //     attrs: params => {
        //       const data = params.data
        //       return {
        //         useRoute: true,
        //         usePrint: false,
        //         jumpMethod: value => {
        //           jumpFinaceOrBusiness(this, value, '', data.branchId)
        //         },
        //         printMethod: this.toSearchTemplate
        //       }
        //     }
        //   }
        // },

        // CARGO-33759 【付款申请】模块，付款申请号里存在多个费用业务编号，全部展示 由原先的jobNo展示一个业务编号调整为jobNos能展示多个业务编号
        {
          headerName: this.$t('Payment.businessNumber'),
          field: 'jobNos',
          enableRowGroup: true,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            tag: 'multi-router-and-print',
            attrs: params => {
              const data = params.data
              return {
                useRoute: true,
                usePrint: true,
                jumpMethod: value => {
                  jumpFinaceOrBusiness(this, value, '', data.branchId)
                },
                printMethod: this.toSearchTemplate
              }
            }
          },
          width: 200
        },
        {
          headerName: this.$t('Invoice.invoice_itemNo'),
          field: 'jobPono',
          hide: true,
          width: 200
        },
        {
          headerName: this.$t('Payment.dateOfApplication'),
          field: 'inputDate',
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Payment.applicant'), field: 'inputBy', width: 200, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Payment.applicationDepartment'), field: 'inputByDep', width: 200, enableRowGroup: true,
          cellRenderer: (params) => {
            return params.value ? ColumnUtils.departmentLabelNewFunc(Number(params.value)) : ''
          }
        },
        {
          headerName: this.$t('Payment.paymentPeriod'), field: 'deadline', width: 200, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Payment.methodOfPayment'), field: 'payType', width: 200, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.amountReceiveTypeLabelFun(Number(params.value))
          }
        },
        {
          headerName: this.$t('Partners.isFba'),
          colId: 'fba',
          field: 'fba',
          width: 180,
          hide: true,
          enableRowGroup: true,
          valueFormatter: (params) => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          }
        },
        {
          headerName: this.$t('baseInfo.mailingAddress.fbaWarehouseCode'),
          colId: 'warehouseCode',
          field: 'warehouseCode',
          width: 180,
          enableRowGroup: true,
          hide: true
        },
        {
          headerName: this.$t('FbaJob.DestinationDistribution'),
          colId: 'destinationDistribution',
          field: 'destinationDistribution',
          width: 180,
          hide: true,
          enableRowGroup: true,
          valueFormatter: (params) => {
            return ColumnUtils.multipleFbaDestinationDistribution(TYPE_NAMES.local_cache_FbaJobConstants$DESTINATION_DISTRIBUTION_LIST, 'code', params.value)
          }
        },
        {
          headerName: this.$t('FbaJob.ExpressNo'),
          colId: 'expressNo',
          field: 'expressNo',
          width: 180,
          enableRowGroup: true,
          hide: true
        },
        {
          headerName: this.$t('FbaJob.RemoteWarehouse'),
          colId: 'remoteWarehouse',
          field: 'remoteWarehouse',
          width: 180,
          hide: true,
          enableRowGroup: true,
          valueFormatter: (params) => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          }
        },
        {
          headerName: 'Shipment Id',
          colId: 'shipmentId',
          field: 'shipmentId',
          width: 180,
          enableRowGroup: true,
          hide: true
        },
        {
          headerName: 'Reference Id',
          colId: 'referenceId',
          field: 'referenceId',
          width: 180,
          enableRowGroup: true,
          hide: true
        },
        {
          headerName: this.$t('Invoice.invoice_invoiceNo'), field: 'invoiceNos', width: 200, hide: !this.showInvoiceNoColumn, enableRowGroup: true
        },
        {
          headerName: this.$t('Payment.currency'), field: 'currency', width: 200, enableRowGroup: true
        },
        {
          headerName: this.$t('Payment.amount'), field: 'amount', width: 200, enableRowGroup: true,
          cellRenderer: (params) => {
            return NumberUtils.formatRoundNumber(params.value, 2)
          },
          summaryMode: 'sum'
        },
        // {
        //   headerName: this.$t('Payment.theAmountOfWriteOffs'), field: 'verifiedAmount', width: 200,
        //   cellRenderer: (params) => {
        //     return params.value === 0 ? '' : NumberUtils.formatRoundNumber(params.value, 2)
        //   },
        //   hide: !this.showVerifiedAmount
        // },
        {
          headerName: this.$t('Payment.currencyAmountOfWriteOffs'), field: 'currencyVerifiedAmount', width: 200, hide: !this.showVerifiedAmount, enableRowGroup: true,
          summaryMode: 'sum'
        },
        {
          headerName: this.$t('WriteOff.approvalStatus'),
          field: 'state',
          enableRowGroup: true,
          cellRenderer: (params) => {
            if (this.isItACommercialAudit && params.value && parseInt(params.value) === 2) {
              return this.$t('CargoMsg.Cargo_OfficeApproved')
            }
            return ColumnUtils.billPaymentStateLabelFunc(Number(params.value))
          }
        },
        {
          headerName: this.isItACommercialAudit ? this.$t('WriteOff.officeAuditor') : this.$t('WriteOff.businessAuditor'), field: 'businessVerifier', width: 200,
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          },
          hide: true
        },
        {
          headerName: this.isItACommercialAudit ? this.$t('WriteOff.officeAuditDate') : this.$t('WriteOff.businessAuditDate'), field: 'businessVerifyDate', width: 200,
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          hide: true
        },
        {
          headerName: this.$t('WriteOff.financialAuditor'), field: 'financeVerifier', width: 200, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          },
          hide: true
        },
        {
          headerName: this.$t('WriteOff.financialAuditDate'), field: 'financeVerifyDate', width: 200, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          hide: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SupervisorReviewer'), field: 'supervisorVerifier', width: 200, enableRowGroup: true,
          cellRenderer: (params) => {
            if (params.value === -1) {
              return this.$t('CargoMsg.Cargo_NoReviewRequired')
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          },
          hide: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SupervisorReviewDate'), field: 'supervisorVerifyDate', width: 200, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          hide: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SettlementUnitContractStatus'), field: 'settlementUnitContractStatus', width: 200, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.settlementUnitContractStatusLabelFun(Number(params.value))
          },
          hide: true
        },
        {
          headerName: this.$t('WriteOff.departmentAuditor'), field: 'departmentVerifier', width: 200, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          },
          hide: true
        },
        {
          headerName: this.$t('WriteOff.departmentAuditDate'), field: 'departmentVerifyDate', width: 200, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          hide: true
        },
        {
          headerName: this.$t('WriteOff.verificationStatus'), field: 'realClearingState', width: 200, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.clearingStateLabFun(Number(params.value))
          },
          hide: !this.showRealClearingState
        },
        {
          headerName: this.$t('Payment.remarks'), field: 'remark', width: 200, enableRowGroup: true
        },
        {
          headerName: this.$t('Payment.workflowNo'), field: 'workflowNo', width: 200, enableRowGroup: true
        },
        {
          headerName: this.$t('Payment.totalCurrency'), field: 'currencyAmount', width: 200, enableRowGroup: true
        },
        {
          headerName: this.$t('WriteOff.proofNo'), field: 'voucherNo', width: 200, enableRowGroup: true
        },
        {
          headerName: this.$t('WriteOff.voucherCreateDate'), field: 'voucherCreateDate', width: 200, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('WriteOff.targetVoucherNo'), field: 'targetVoucherNo2Charge', width: 200, hide: true, enableRowGroup: true
        },
        {
          headerName: this.$t('Payment.invoice_voucherDate'), field: 'voucherDate2Charge', width: 200, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          hide: true
        },
        {
          headerName: this.$t('Payment.lastInvoicingDate'), field: 'lastInvoiceDate', width: 200, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          hide: true
        },
        {
          headerName: this.$t('Payment.bankOfDeposit'), field: 'buyerBank', width: 200, hide: true, enableRowGroup: true
        },
        {
          headerName: this.$t('Payment.bankAccount'), field: 'buyerBankAccount', width: 200, hide: true, enableRowGroup: true
        },
        {
          headerName: this.$t('Payment.mbl'),
          field: 'mbl',
          width: 200,
          cellRendererFramework: 'CargoGridShowBigContent',
          enableRowGroup: true,
          tooltipValueGetter: () => {},
          hide: true
        },
        {
          headerName: this.$t('SeaExport.Carrier'), field: 'carrierChineseName', width: 300,
          valueFormatter: (params) => {
            return ColumnUtils.carrierForBillPaymentLabelFunc(params.data)
          }
        },
        { headerName: this.$t('SeaExport.ConsignationRelationNumber'), colId: 'trustFromJob', field: 'trustFromJob', hide: true, width: 120, enableRowGroup: true },
        { headerName: this.$t('SeaExport.BusinessCommissionedRelationNumber'), colId: 'relatedJob', field: 'relatedJob', hide: true, width: 120, enableRowGroup: true },
        {
          headerName: this.$t('queryJob.placeOfDelivery'),
          field: 'destinationPlace',
          colId: 'destinationPlace',
          width: 200,
          enableRowGroup: true,
          hide: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CooperateBranchId'),
          colId: 'cooperatebranch',
          field: 'cooperatebranch',
          width: 160, minWidth: 160,
          enableRowGroup: true,
          hide: !this.useOrderCenterMode
        }, {
          headerName: this.$t('CargoMsg.Cargo_CooperateBusinessType'),
          colId: 'cooperateBusinessType',
          field: 'cooperateBusinessType',
          width: 200, minWidth: 200,
          enableRowGroup: true,
          hide: !this.useOrderCenterMode
        }, {
          headerName: this.$t('CargoMsg.Cargo_AccountPeriod'),
          field: '',
          width: 100,
          hide: true,
          suppressColumnsToolPanel: !this.showCreditPeriod,
          cellRenderer: params => ColumnUtils.getAccountPeriod(params.data)
        },
        {
          headerName: this.$t('Payment.bdApproveState'),
          field: 'bdApproveState',
          colId: 'bdApproveState',
          width: 200,
          hide: true,
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.billPaymentApproveStateLabelFunc(Number(params.value))
          },
          filterValueGetter: (params) => {
            return ColumnUtils.billPaymentApproveStateLabelFunc(Number(params.value))
          }
        },
        {
          headerName: this.$t('Payment.ccApproveState'),
          field: 'ccApproveState',
          colId: 'ccApproveState',
          width: 200,
          hide: true,
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.billPaymentApproveStateLabelFunc(Number(params.value))
          },
          filterValueGetter: (params) => {
            return ColumnUtils.billPaymentApproveStateLabelFunc(Number(params.value))
          }
        },
        {
          headerName: this.$t('Payment.finApproveState'),
          field: 'finApproveState',
          colId: 'finApproveState',
          width: 200,
          hide: true,
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.billPaymentApproveStateLabelFunc(Number(params.value))
          },
          filterValueGetter: (params) => {
            return ColumnUtils.billPaymentApproveStateLabelFunc(Number(params.value))
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_dispatchingPlace2'),
          field: 'jobDispatchingPlace',
          colId: 'jobDispatchingPlace',
          enableRowGroup: true,
          width: 120
        },
        {
          headerName: this.$t('CargoMsg.Cargo_actTakeTime'),
          field: 'actTakeTime',
          colId: 'actTakeTime',
          enableRowGroup: true,
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AgentBillNo'),
          field: 'counterPartyBillingNos',
          colId: 'counterPartyBillingNos',
          width: 200,
          enableRowGroup: true,
          hide: true
        },
        {
          headerName: this.$t('Payment.billNo'),
          field: 'billingNos',
          colId: 'billingNos',
          width: 200,
          enableRowGroup: true,
          hide: true
        },
        /*, {
          headerName: this.$t('CargoMsg.Cargo_userDefinedRole1'),
          field: 'userDefinedRoleId1',
          colId: 'userDefinedRoleId1',
          width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.getUserDefinedLabel(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_userDefinedRole2'),
          field: 'userDefinedRoleId2',
          colId: 'userDefinedRoleId2',
          width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.getUserDefinedLabel(params.value)
          }
        }*/
        {
          headerName: this.$t('FinanceManage.charge_whtTaxAmount'), field: 'whtTaxLocalAmount', width: 100,
          hide: !this.showWhtTax,
          suppressColumnsToolPanel: !this.showWhtTax,
          enableRowGroup: true,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          summaryMode: 'sum'
        },
        {
          headerName: this.$t('FinanceManage.charge_notWhtAmount'), field: 'notWhtAmount', width: 100,
          hide: !this.showWhtTax,
          suppressColumnsToolPanel: !this.showWhtTax,
          enableRowGroup: true,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          summaryMode: 'sum'
        },
        {
          headerName: this.$t('Partners.paymentType'), field: 'paymentType', width: 200, enableRowGroup: true, hide: true,
          cellRenderer: (params) => {
            if (String(params.value) === '') {
              return ''
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_PaymentType, 'code', String(params.value), 'name')
          },
          filterParams: {},
          filterValueGetter: (params) => {
            const paymentType = params.data.paymentType
            if (paymentType === '' || paymentType === undefined) {
              return ''
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_PaymentType, 'code', paymentType, 'name')
          }
        },
        {
          headerName: 'SERVICE',
          field: 'whtService',
          hide: !this.showWhtTax,
          suppressColumnsToolPanel: !this.showWhtTax,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          width: 100,
          summaryMode: 'sum'
        },
        {
          headerName: 'ADVANCE',
          field: 'whtAdvance',
          hide: !this.showWhtTax,
          suppressColumnsToolPanel: !this.showWhtTax,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          width: 100,
          summaryMode: 'sum'
        },
        {
          headerName: 'VAT',
          field: 'whtVat',
          hide: !this.showWhtTax,
          suppressColumnsToolPanel: !this.showWhtTax,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          width: 100,
          summaryMode: 'sum'
        },
        {
          headerName: this.$t('FinanceManage.CostType'),
          colId: 'costControlType',
          field: 'costControlType',
          width: 180,
          valueFormatter: (params) => {
            return ColumnUtils.resolveCostType(params.value, 'chineseName')
          },
          hide: true,
          enableRowGroup: true
        },
        {
          headerName: 'ETA',
          field: 'etas',
          colId: 'etas',
          width: 200,
          enableRowGroup: true,
          hide: true
        },
        {
          headerName: 'ETD',
          field: 'etds',
          colId: 'etds',
          width: 200,
          enableRowGroup: true,
          hide: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PrintOrNot'),
          colId: 'hasPrint',
          field: 'hasPrint',
          width: 180,
          hide: true,
          enableRowGroup: true,
          valueFormatter: (params) => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          }
        },
        {
          headerName: this.$t('Payment.accountStatementNo'),
          field: 'billingGroupNos',
          colId: 'billingGroupNos',
          width: 200,
          enableRowGroup: true,
          hide: true
        }
      ]
      if (this.state.includes(ClearingConstants.BILL_PAYMENT_APPROVED_BPM.code)) {
        columnDefs.push(
          {
            headerName: this.$t('CargoMsg.Approval_Approved_Time'),
            field: 'approvalApprovedTime',
            colId: 'approvalApprovedTime',
            width: 120,
            hide: true,
            enableRowGroup: true,
            cellRenderer: (params) => {
              return ColumnUtils.dateTimeLabelFunc(params.value)
            }
          })
      }
      if (this.state.includes(ClearingConstants.BILL_PAYMENT_WEAVER_APPROVED.code)) {
        columnDefs.push({
          headerName: this.$t('CargoMsg.Cargo_BillDate2'), field: 'accountingDateLabel', colId: 'accountingDateLabel', width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_FinancialPayStatus'),
          field: 'apStateLabel',
          colId: 'apStateLabel',
          width: 130,
          cellRenderer: (params) => {
            let value = ''
            if (params.value) {
              const arr = params.value.split(',')
              for (const index in arr) {
                if (index > 0) value += '/'
                value += ColumnUtils.showTypeLabelFunc(Number(params.value), SystemConstants.SHARED_TYPES)
              }
            }
            return value
          },
          filterParams: {},
          filterValueGetter: (params) => {
            let value = ''
            if (params.data.apStateLabel) {
              const arr = params.data.apStateLabel.split(',')
              for (const index in arr) {
                if (index > 0) value += '/'
                value += ColumnUtils.showTypeLabelFunc(Number(params.data.apStateLabel), SystemConstants.SHARED_TYPES)
              }
            }
            return value
          }
        })
      }
      if (this.isBpm) {
        columnDefs.push(
          {
            headerName: this.$t('CargoMsg.Cargo_ApprovalSerialNumber'),
            field: 'documentProcessNo',
            colId: 'documentProcessNo',
            width: 200,
            hide: true,
            excelRenderer: (params) => {
              if (params.value) {
                return params.value
              }
              return ''
            },
            cellRenderer: (params) => {
              if (params.value) {
                const methodPath = this.documentManage.getPath('showWorkFlowApplyDialog')
                return `<a onclick="${methodPath}(${params.data.documentProcessId})" style="color:blue">` + params.value + '</a>'
              }
              return ''
            },
            filterParams: {},
            filterValueGetter: (params) => {
              return params.data.documentProcessNo ? params.data.documentProcessNo : ''
            }
          }
        )
      }
      return columnDefs
    },
    totalAmountNotWrittenOffLabel() {
      if (this.totalAmountToCurrencyBillPaymentGrid.dataProvider.length > 0) {
        return this.$t('Billing.billingJob_totalAmountNotWrittenOff')
      } else {
        return ''
      }
    },
    useOrderCenterMode() { // 是否开启接单中心模式
      return RateUtil.useOrderCenterMode()
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      async handler() {
        await this.initCustomSearchItems()
      }
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.isItACommercialAudit = Number(cache.config.get('IsItACommercialAudit')) === 1
    this.dataListDragGroup = Number(cache.config.get('DataListDragGroup')) === 1
    await this.initConfig()
    await ensureExecuteSuccess(() => this.defaultSearchItems && this.defaultSearchItems.length > 0)
    await this.initCustomSearchItems()
    this.setLocalCurrency()
  },
  beforeMount() {
    const context = this
    this.documentManage.set('showWorkFlowApplyDialog', function(documentProcessId) {
      WorkflowUtil.showWorkFlowApplyDialog(context, context.workFlowApplyDialog, '', documentProcessId)
    })
  },
  mounted() {
  },
  methods: {
    // 配置参数
    async initConfig() {
      const jobStates = []
      if (this.jobStateParam) {
        this.searchConditions.jobStateParam = String(cache.config.get(this.jobStateParam))
        //
        this.searchConditions.jobStateParam.split(',').forEach(function(value) {
          jobStates.push(Number(value))
        })
      }
      this.searchConditions.jobStates = jobStates
    },
    // 查询
    fetchData(conditions, simpleTriggerMode = false) {
      this.searchConditions.pageNum = 1
      const finallyConditions = []
      const advConditions = lodash.cloneDeep(conditions)
      // 获取追加查询条件
      this.appendQuery = JobUtils.appendQueryCondition(advConditions)
      // 申请日期
      // if (this.viewSource !== 'VoucherList') {
      let inputDate = ''
      if (this.inputDateStart && this.inputDateEnd) {
        inputDate = 'start=' + this.inputDateStart + ' 00:00:00' + ',end=' + this.inputDateEnd + ' 23:59:59'
      } else if (!this.inputDateStart && this.inputDateEnd) {
        inputDate = 'end=' + this.inputDateEnd + ' 23:59:59'
      } else if (this.inputDateStart && !this.inputDateEnd) {
        inputDate = 'start=' + this.inputDateStart + ' 00:00:00'
      }
      if (inputDate) {
        const condition = new AdvancedSearchOption(null, 'billPayment.INPUTDATE', inputDate + ',type=date', OperatorConstants.OPERATOR_RANGE.code)
        finallyConditions.push(condition.formatObj2Json())
      }
      // }
      // 锦昶应付单 排除已经使用过付款申请
      if (this.viewSource === 'financeAp') {
        const condition = new AdvancedSearchOption(null, 'billPayment.financeAp', 'financeAp', OperatorConstants.OPERATOR_UNEQUAL.code)
        finallyConditions.push(condition.formatObj2Json())
      }
      if (this.viewSource === 'Writeoff') {
        const condition = new AdvancedSearchOption(null, 'billPayment.writeoff', 'writeoff', OperatorConstants.OPERATOR_UNEQUAL.code)
        finallyConditions.push(condition.formatObj2Json())
      }
      // 审批状态
      const paymentStateOption = AdvancedSearchOption.removeOption('billPayment.STATE', advConditions)
      if (paymentStateOption) {
        const value = paymentStateOption.value
        if (value instanceof Array && value.includes(BILL_PAYMENT_BIZ_APPROVED.code)) {
          value.push(BILL_PAYMENT_DEP_APROVED.code)
        }
        finallyConditions.push(paymentStateOption)
      } else {
        // 付款申请状态
        if (this.state && this.state.length > 0) {
          const option = new AdvancedSearchOption(null, 'billPayment.STATE', this.state, OperatorConstants.OPERATOR_IN.code)
          finallyConditions.push(option.formatObj2Json())
        }
      }
      // 是否核销
      if (this.paidOff > -1) {
        const option = new AdvancedSearchOption(null, 'charge.PAID_OFF', this.paidOff, OperatorConstants.OPERATOR_EQUAL.code)
        finallyConditions.push(option.formatObj2Json())
      }
      if (this.finApproveState && this.finApproveState.length > 0) {
        AdvancedSearchOption.removeOption('billPayment.FIN_APPROVE_STATE', advConditions)
        const option = new AdvancedSearchOption(null, 'billPayment.FIN_APPROVE_STATE', this.finApproveState, OperatorConstants.OPERATOR_IN.code)
        finallyConditions.push(option.formatObj2Json())
      }
      // 业务状态
      if (this.searchConditions.jobStates && this.searchConditions.jobStates.length > 0 &&
        this.jobStateParam !== 'BillPaymentJobState' &&
        !LoadDefaultQueryParam.isSelectOption(conditions, "job.JOB_STATE'")) {
        const option = new AdvancedSearchOption(null, 'job.JOB_STATE', this.searchConditions.jobStates, OperatorConstants.OPERATOR_IN.code)
        finallyConditions.push(option.formatObj2Json())
      }
      // 是否查询受控费用
      if (!this.showControlledCharge) {
        // 是否有应付受控费用权限
        const isControlled = this.$checkPermission(['button_Charge_controlled'])
        // 是否有应收受控费用权限
        const isCostControlled = this.$checkPermission(['button_Charge_costControlled'])
        let value = 0
        if (!isControlled && !isCostControlled) {
          value = 1
        } else if (!isControlled) {
          value = 2
        } else if (!isCostControlled) {
          value = 3
        }
        if (value !== 0) {
          const option = new AdvancedSearchOption(null, 'cIsControlled', value, OperatorConstants.OPERATOR_EQUAL.code)
          finallyConditions.push(option.formatObj2Json())
        }
      }
      if (this.exceptKeys.length > 0) {
        const option = new AdvancedSearchOption(null, 'billPayment.UUID', this.exceptKeys, OperatorConstants.OPERATOR_NOT_IN.code)
        finallyConditions.push(option.formatObj2Json())
      }
      if (this.exceptAdvancedSearchOption) {
        finallyConditions.push(this.exceptAdvancedSearchOption.formatObj2Json())
      }
      if (this.selectedEntitiesForHedging.length > 0) {
        const option = new AdvancedSearchOption(null, 'selectedEntitiesForHedging', this.selectedEntitiesForHedging, OperatorConstants.OPERATOR_EQUAL.code)
        finallyConditions.push(option.formatObj2Json())
      }
      if (this.showVerifiedAmount || this.showRealClearingState) { this.searchConditions.requires.push('writeoff') }
      if (this.showInvoiceNoColumn) { this.searchConditions.requires.push('invoiceNo') }
      if (this.isCheckCharge) { this.searchConditions.requires.push('checkCharge') }
      if (this.showFba) { this.searchConditions.requires.push('fba') }
      if (this.isBpm) { this.searchConditions.requires.push('bpm') }
      if (this.state.includes(ClearingConstants.BILL_PAYMENT_WEAVER_APPROVED.code)) { this.searchConditions.requires.push('financeAp') }
      if (this.showWhtTax) { this.searchConditions.requires.push('whtTax') }

      finallyConditions.push(...advConditions)
      // 结算单位
      if (this.accountId > 0 && !AdvancedSearchOption.hasField('billPayment.ACCOUNTID', conditions)) {
        const option = new AdvancedSearchOption(null, 'billPayment.ACCOUNTID', this.accountId, OperatorConstants.OPERATOR_EQUAL.code)
        finallyConditions.push(option.formatObj2Json())
      }
      // 是否生成凭证
      if (this.hasVoucher !== -1 && !StrUtils.isEmpty(this.accountSetKey)) {
        finallyConditions.push(new AdvancedSearchOption(null, SpecialFieldConstants.BILLPAYMENT_VOUCHERED, { 'accountSetKey': this.accountSetKey }, this.hasVoucher === 1 ? AdvancedSearchConsts.OPERATOR_IN.code : AdvancedSearchConsts.OPERATOR_NOT_IN.code).formatObj2Json())
      }
      // 内结
      if (this.internalCharge) {
        const condition = new AdvancedSearchOption(null, 'charge.INTERNAL', true, OperatorConstants.OPERATOR_EQUAL.code)
        finallyConditions.push(condition.formatObj2Json())
      }
      // 条件保存
      this.searchConditions.snapshotConditions = finallyConditions
      this.toQueryBillPaymentList()
    },
    // 快捷检索
    fetchDataBykeyWord(keyWord) {
      if (!StrUtils.isEmpty(keyWord)) {
        this.searchConditions.pageNum = 1
        const conditions = []
        const option = new AdvancedSearchOption(null, 'billPayment.BILLPAYMENTNO', keyWord, OperatorConstants.OPERATOR_LIKE.code)
        conditions.push(option.formatObj2Json())
        //
        if (conditions.length > 0) {
          this.appendQuery = false
          this.fetchData(conditions, true)
        }
      }
    },
    // 分页触发查询
    fetchDataByPage(param) {
      this.toQueryBillPaymentList()
    },
    reQuery() {
      this.$refs[this.identify].advSearch()
    },
    toQueryBillPaymentList(data = null) {
      this.queryOfficeId = this.$store.getters.currentOfficeId
      const { snapshotConditions: conditions, requires, pageNum, pageSize } = this.searchConditions
      const finalRequires = [...requires, 'creditInfo']
      const requestBody = { conditions, requires: finalRequires, branchId: (this.accountSetBranchId ? this.accountSetBranchId : this.$store.getters.currentOfficeId), pageNum, pageSize }
      requestBody.appendQuery = this.appendQuery
      requestBody.defaultBillPayment = this.isDefaultBillPayment
      requestBody.queryMasterDb = data ? (data.queryMasterDb || false) : false
      this.loading = getLoading()
      const selectedStatus = recordSelectedStatus(this.billPaymentGrid.gridOptions.api, 'uuid')
      this.queryBillPaymentListExcludeKeys(requestBody, data ? data.keys : []).then(res => {
        let results = res.data.list
        if (results && results.length > 0) {
          // 追加查询数据去重
          if (this.appendQuery) {
            results = JobUtils.appendQueryRepeat(this.billPaymentGrid.rowData, results, this.appendQuery)
          }
          this.billPaymentGrid.rowData = results
          this.searchConditions.total = this.appendQuery ? results.length : Number(res.data.total)
          if (this.isAr === -1) {
            this.totalAmountToCurrencyBillPaymentGrid.labelText = this.$t('Message.All2')
          } else if (this.isAr === 0) {
            this.totalAmountToCurrencyBillPaymentGrid.labelText = this.$t('Clearing.Payable')
          } else if (this.isAr === 1) {
            this.totalAmountToCurrencyBillPaymentGrid.labelText = this.$t('Clearing.Receivable')
          }
          this.totalAmountToCurrencyBillPaymentGrid.selectionCountLabel = ''
          this.totalAmountToCurrencyBillPaymentGrid.dataProvider = this.billPaymentGrid.rowData
          this.totalAmountToCurrencyBillPaymentGrid.selectedCount = 0
        } else {
          this.billPaymentGrid.rowData = []
          this.searchConditions.total = 0
          this.totalAmountToCurrencyBillPaymentGrid.labelText = ''
          this.totalAmountToCurrencyBillPaymentGrid.selectionCountLabel = ''
          this.totalAmountToCurrencyBillPaymentGrid.dataProvider = []
          this.totalAmountToCurrencyBillPaymentGrid.selectedCount = 0
        }
        this.$emit('dataProviderChange', { data: this.billPaymentGrid.rowData, searchConditions: this.searchConditions })
        selectedStatus.revert()
      }).catch(() => {
        this.loading.close()
      }).finally(() => {
        this.loading.close()
      })
    },
    /**
     * 这里针对主库从库同步不及时的问题，第一次查询时，如果数据中存在旧数据（正常不应该查出来），则重新查询
     * @param data - 查询参数
     * @param excludeKeys - 需要排除的旧数据的记录keys
     * @returns
     */
    async queryBillPaymentListExcludeKeys(data, excludeKeys) {
      let res = await queryBillPaymentList(data)
      if (excludeKeys && res.data.list && res.data.list.findIndex(p => excludeKeys.includes(p.uuid)) > -1) {
        res = await queryBillPaymentList(data)
      }
      return res
    },
    //
    async initCustomSearchItems() {
      // 业务状态
      const defaultSearchFields = []
      let jobStates = []
      if (this.jobStateParam) {
        jobStates = await LoadDefaultQueryParam.getConfigQueryParam(this.jobStateParam, SystemConstants.JOB_STATES)
      }
      const searchField = new AdvancedSearchField()
      searchField.action = 2
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.itemValue = []
      searchField.itemLabel = 'Billing.billingCharge_businessStatus'
      searchField.itemName = 'job.JOB_STATE'
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.dataProvider = jobStates
      defaultSearchFields.push(searchField.formatObj2Json())
      // 默认结算单位
      if (this.accountId > 0) {
        const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.accountId))
        if (company) {
          const searchField = new AdvancedSearchField()
          const options = [{ code: company.cmpIdx, chineseName: company.chineseName, englishName: company.englishName }]
          searchField.itemType = 'select'
          searchField.multiple = 0
          searchField.defaultValue = this.accountId
          searchField.itemLabel = 'WriteOff.settleAccountsTo'
          searchField.itemName = 'billPayment.ACCOUNTID'
          searchField.fieldType = 'FIELD_COMPANY'
          searchField.lock = true
          searchField.dataProvider = options
          searchField.action = 2
          searchField.defaultSelected = 1
          searchField.selected = 1
          defaultSearchFields.push(searchField.formatObj2Json())
        }
      }
      // 申请日期
      if (this.viewSource === 'Writeoff') {
        let searchField = new AdvancedSearchField()
        searchField.action = 1
        searchField.itemType = 'date'
        searchField.fieldType = 'FIELD_DATE_RANGE'
        searchField.itemCondition = []
        searchField.subType = 'range'
        searchField.defaultConditionVal = ''
        searchField.itemName = 'billPayment.INPUTDATE'
        searchField.itemLabel = 'WriteOff.dateOfApplication'
        searchField.itemValue = []
        searchField.selected = 0
        searchField.valueExpression = ''
        searchField.lock = false
        searchField.defaultValue = []
        defaultSearchFields.push(searchField.formatObj2Json())
        // 是否已核销
        searchField = new AdvancedSearchField()
        searchField.action = 1
        searchField.itemType = 'select'
        searchField.fieldType = 'FIELD_CHECKBOX'
        searchField.itemCondition = []
        searchField.defaultConditionVal = ''
        searchField.itemName = 'charge.PAID_OFF'
        searchField.itemLabel = 'WriteOff.wroteOffOrNot'
        searchField.itemValue = ''
        searchField.selected = 0
        searchField.valueExpression = ''
        searchField.lock = false
        searchField.defaultValue = ''
        defaultSearchFields.push(searchField.formatObj2Json())
        // 最晚开票日期
        searchField = new AdvancedSearchField()
        searchField.action = 1
        searchField.itemType = 'date'
        searchField.fieldType = 'FIELD_DATE_RANGE'
        searchField.itemCondition = []
        searchField.defaultConditionVal = ''
        searchField.itemName = 'lidCharge.lastInvoiceDate'
        searchField.itemLabel = 'Payment.lastInvoicingDate'
        searchField.itemValue = ''
        searchField.selected = 0
        searchField.valueExpression = ''
        searchField.lock = false
        searchField.defaultValue = ''
        defaultSearchFields.push(searchField.formatObj2Json())
        // 审批状态
        searchField = new AdvancedSearchField()
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemValue = []
        searchField.itemLabel = 'WriteOff.approvalStatus'
        searchField.itemName = 'billPayment.STATE'
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.defaultSelected = 1
        searchField.dataProvider = [BILL_PAYMENT_NOT_COMMIT, BILL_PAYMENT_COMMITED, BILL_PAYMENT_BIZ_APPROVED, BILL_PAYMENT_FINANCE_APPROVED, BILL_PAYMENT_APPROVING_BPM, BILL_PAYMENT_APPROVED_BPM]
        defaultSearchFields.push(searchField.formatObj2Json())
      } else {
        // 移除审批状态
        const searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.REMOVE_ACTION
        searchField.itemType = 'select'
        searchField.itemName = 'billPayment.STATE'
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      // 付款申请
      if (['billPaymentList', 'financeAp'].includes(this.viewSource)) {
        defaultSearchFields.push({
          'action': AdvancedSearchField.UPDATE_ACTION,
          'itemType': 'multiText',
          'subType': '',
          'fieldType': 'FIELD_MULTI_TEXT',
          'itemCondition': [],
          'defaultConditionVal': '',
          'itemName': 'billPayment.BILLPAYMENTNO',
          'itemLabel': 'WriteOff.applicationNo',
          'itemValue': '',
          'defaultSelected': 1,
          'selected': 0,
          'valueExpression': '',
          'lock': false,
          'defaultValue': ''
        })
        if (this.state.includes(ClearingConstants.BILL_PAYMENT_APPROVED_BPM.code)) {
          const searchField = new AdvancedSearchField()
          searchField.action = AdvancedSearchField.ADD_ACTION
          searchField.itemType = 'date'
          searchField.fieldType = 'FIELD_DATE_RANGE'
          searchField.itemCondition = []
          searchField.subType = 'range'
          searchField.defaultConditionVal = ''
          searchField.itemName = 'billPayment.APPROVAL_APPROVED_TIME'
          searchField.itemLabel = 'CargoMsg.Approval_Approved_Time'
          searchField.itemValue = []
          searchField.selected = 0
          searchField.valueExpression = ''
          searchField.lock = false
          searchField.defaultValue = []
          defaultSearchFields.push(searchField.formatObj2Json())
        }
      }
      if (this.useOrderCenterMode) {
        const officeAll = getCacheListByKey(basicCacheKeys.basic_data_Office_All)
        const offices = officeAll.filter(p => p.code !== 'HQ').sort((office1, office2) => office1.officeId > office2.officeId ? 1 : -1)
        offices.forEach(row => { row.code = row.officeId }) // ID
        let searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = 0
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'cooperate.BRANCH_ID'
        searchField.itemLabel = 'CargoMsg.Cargo_CooperateBranchId'
        searchField.itemValue = []
        searchField.tagValue = 'officeId'
        searchField.defaultSelected = 1
        searchField.selected = 0
        searchField.dropdownDataRef = ''
        searchField.lock = false
        searchField.defaultValue = []
        searchField.dataProvider = offices
        defaultSearchFields.push(searchField.formatObj2Json())
        // 协作业务类型
        const cooperationTypes = getCacheListByKey(basicCacheKeys.basic_data_CooperationType)
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = 0
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'cooperate.BUSINESS_TYPE'
        searchField.itemLabel = 'CargoMsg.Cargo_CooperateBusinessType'
        searchField.itemValue = []
        searchField.defaultSelected = 1
        searchField.selected = 0
        searchField.dropdownDataRef = ''
        searchField.lock = false
        searchField.defaultValue = []
        searchField.dataProvider = cooperationTypes
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      // CARGO-36729 付款申请新版隐藏查询项
      if (this.isBpm) {
        // 移除业务审批状态
        let searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.REMOVE_ACTION
        searchField.itemType = 'select'
        searchField.itemName = 'billPayment.BD_APPROVE_STATE'
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        defaultSearchFields.push(searchField.formatObj2Json())
        // 移除财务审批状态
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.REMOVE_ACTION
        searchField.itemType = 'select'
        searchField.itemName = 'billPayment.CC_APPROVE_STATE'
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        defaultSearchFields.push(searchField.formatObj2Json())
        // 移除最终审批状态
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.REMOVE_ACTION
        searchField.itemType = 'select'
        searchField.itemName = 'billPayment.FIN_APPROVE_STATE'
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        defaultSearchFields.push(searchField.formatObj2Json())
        // CARGO-39771 BPM各审批流增加快捷入口（增加审批流水号）
        searchField = new AdvancedSearchField()
        searchField.itemType = 'input'
        searchField.operationType = 'text6'
        searchField.fieldType = 'FIELD_TEXT'
        searchField.itemName = 'approvalForm.DOCUMENT_PROCESS_NO'
        searchField.itemLabel = 'CargoMsg.Cargo_ApprovalSerialNumber'
        searchField.itemValue = ''
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.lock = false
        searchField.defaultValue = ''
        searchField.action = AdvancedSearchField.ADD_ACTION
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      if (this.$checkPermission(['role_ViewHierarchicalListAtFinancial']) || this.$checkPermission(['role_ViewHierarchicalDetailAtFinancial'])) {
        JobUtils.configSearchItemsChildOffice(this.defaultSearchItems, defaultSearchFields)
      }
      this.customSearchItems = defaultSearchFields
    },
    onRowSelected(event) {
      console.log('onRowSelected', event.data)
      this.selectedItem = {}
      if (event.node.selected && event.data) {
        this.selectedItem = event.data
      }
    },
    onRowClicked(event) {
      console.log('onRowClicked', event.data)
      this.selectedItem = event.data
    },
    onRowDoubleClicked(event) {
      console.log('onRowDoubleClicked', event.data)
      this.selectedItem = event.data
      this.$emit('rowDoubleClicked', this.selectedItem)
    },
    getSelections() { // 获取勾选的项目
      return getGridSelected(this.billPaymentGrid.gridOptions)
    },
    // 是否红冲
    isRedPunch() {
      return false
    },
    updateRowDataInformation(dataArray = null) { // 修改列表的属性
      const rowData = this.billPaymentGrid.rowData
      if (dataArray) {
        for (const billPayment of rowData) {
          for (const item of rowData) {
            if (item.uuid && billPayment.uuid && item.uuid === billPayment.uuid) {
              Object.assign(billPayment, item)
            }
          }
        }
      }
    },
    changeDataProvider(rowData = [], searchConditions = {}) { // 修改列表数据源以及查询条件
      this.billPaymentGrid.rowData = rowData
      this.searchConditions = searchConditions
      this.refreshSelectedCountChargeGrid()
    },
    // 列表checkBox选中变更事件
    toRefreshSelectedCountChargeGrid(event) {
      console.log('toRefreshSelectedCountChargeGrid', event)
      this.filterChange()
    },
    filterChange() {
      this.selections = getGridSelected(this.billPaymentGrid.gridOptions)
      this.dataShow = true
      if (this.selections.length > 0) {
        this.once.excute(this.refreshSelectedCountChargeGrid, [0, this.selections], 200)
      } else {
        this.$nextTick(() => {
          const hasDisplay = []
          this.billPaymentGrid.gridOptions.api.forEachNode(node => {
            if (node.displayed) {
              hasDisplay.push(node.data)
            }
          })
          if (hasDisplay.length > 0) {
            if (hasDisplay.length == this.billPaymentGrid.rowData.length) {
              this.once.excute(this.refreshSelectedCountChargeGrid, [], 200)
            }
            if (hasDisplay.length < this.billPaymentGrid.rowData.length) {
              this.once.excute(this.refreshSelectedCountChargeGrid, [], 200)
            }
          } else {
            this.dataShow = false
            this.once.excute(this.refreshSelectedCountChargeGrid, [], 200)
          }
        })
      }
    },
    refreshSelectedCountChargeGrid(arg, selections) {
      if (arg == 0) {
        this.totalAmountToCurrencyBillPaymentGrid.selectionCountLabel = this.$t('Clearing.Selected') + selections.length + '：'
        this.totalAmountToCurrencyBillPaymentGrid.dataProvider = selections
        this.totalAmountToCurrencyBillPaymentGrid.selectedCount = selections.length
      } else if (arg == 1) {
        this.totalAmountToCurrencyBillPaymentGrid.selectionCountLabel = ''
        this.totalAmountToCurrencyBillPaymentGrid.dataProvider = selections
        this.totalAmountToCurrencyBillPaymentGrid.selectedCount = 0
      } else {
        this.totalAmountToCurrencyBillPaymentGrid.selectionCountLabel = ''
        this.totalAmountToCurrencyBillPaymentGrid.dataProvider = this.billPaymentGrid.rowData
        this.totalAmountToCurrencyBillPaymentGrid.selectedCount = 0
      }
    },
    // 展示表格首列【业务编号】单元格中搜索图标点击触发事件
    toSearchTemplate(value) {
      this.$emit('toSearchTemplate', value)
    },
    scrollCallback() {
      // this.$nextTick(() => {
      //   const container = document.querySelector('.main-content')
      //   const footer = document.getElementById('footer-wrapper-tab-billpayment')
      //   const containerHeight = container.clientHeight - footer.offsetHeight
      //   const offset = footer.offsetTop - container.scrollTop
      //   if (offset > containerHeight) {
      //     this.shouldFixed = true
      //   } else {
      //     this.shouldFixed = false
      //   }
      // })
    },
    // 刷新列表数据
    refreshRowData(billPayments = []) {
      if (billPayments && billPayments.length > 0 && this.billPaymentGrid.rowData.length > 0) {
        let update = false
        for (const billPayment of billPayments) {
          for (const item of this.billPaymentGrid.rowData) {
            if (item['uuid'] && billPayment['uuid'] && billPayment['uuid'] === item['uuid']) {
              update = true
              item['state'] = billPayment['state']
              break
            }
          }
        }
        if (update) {
          this.billPaymentGrid.gridOptions.api.refreshCells({ force: true })
        }
      }
    },
    updateRealtotal(realtotal) {
      this.$refs.paginationBillPayment.realtotal = realtotal
    },
    setLocalCurrency() {
      this.localCurrency = RateUtil.localCurrencyByOffice()
      if (this.localCurrency !== 'RMB') {
        setTimeout(() => { this.reCalc = false }, 100)
        setTimeout(() => { this.reCalc = true }, 100)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
